import React, { useEffect } from 'react';

declare global {
    interface Window { KAMPYLE_ONSITE_SDK: any; sf_widget: any; }
}

const SurveyScreen = () => {
    useEffect(() => {
        window?.KAMPYLE_ONSITE_SDK?.updatePageView();
    }, []);

    return (
        <div className="widget__overlay--survey">
            <div id="medallia-murphybot-page-survey">
            </div>
        </div>
    )
}

export default SurveyScreen